import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ListingAccuracyText } from '../columns/presence-accuracy/accuracy-text.pipe';
import { AccuracyStatus, SourceAccuracy, SyncStatus } from '@vendasta/listing-products';
import { ActivatedRoute, Router } from '@angular/router';
import { AppleSourceID, BingSourceID, listingIsBeingCreated } from '../../../local-seo';

@Component({
  selector: 'local-seo-listing-sidebar-accuracy',
  templateUrl: './listing-sidebar-accuracy.component.html',
  styleUrl: './listing-sidebar-accuracy.component.scss',
  standalone: false,
})
export class ListingSidebarAccuracyComponent {
  @Input() accuracy: SourceAccuracy;
  @Input() sourceSupportsListings: boolean;
  @Input() isSyncingEnabled: boolean;
  @Input() syncStatus: SyncStatus;
  @Input() sourceId: number;
  @Input() sourceName: string;
  @Input() isListingVerified: boolean;
  @Output() markListingAccurate: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  accuracyText = ListingAccuracyText;
  inaccurateStatus = AccuracyStatus.ACCURACY_STATUS_INACCURATE;
  notFoundStatus = AccuracyStatus.ACCURACY_STATUS_UNKNOWN;
  successSyncStatus = SyncStatus.SYNC_STATUS_SUCCESS;

  accuracySidebarBadgeColor(): string {
    if (this.accuracy?.status === AccuracyStatus.ACCURACY_STATUS_ACCURATE || this.isListingVerified) {
      return 'green';
    }
    return 'yellow';
  }
  canMarkAsAccurate(status: AccuracyStatus): boolean {
    this.accuracy.status;
    if (
      status === AccuracyStatus.ACCURACY_STATUS_INACCURATE ||
      (status === AccuracyStatus.ACCURACY_STATUS_ACCURATE && this.isListingVerified)
    ) {
      return true;
    }
    return false;
  }
  markListingAccurateEvent($event): void {
    this.isListingVerified = $event.checked;
    this.markListingAccurate.emit($event.checked);
  }

  navigateToListingProfile(): void {
    this.router.navigate(['../listing-profile'], {
      queryParamsHandling: 'preserve',
      relativeTo: this.route,
    });
  }

  creatingListing(): boolean {
    return listingIsBeingCreated(this.sourceId, this.isSyncingEnabled, this.accuracy?.status, this.syncStatus);
  }

  daysToPublish(): number {
    switch (this.sourceId) {
      case AppleSourceID:
        return 5;
      case BingSourceID:
        return 30;
    }
  }
}
